import JSDB from '../fromKotlin/nk';
import {badPhoto, emptyPhoto, byteArrayToImg, dateObjectToString, stringToTime} from '../fromKotlin/nkutils';
import {toArrayOrEmpty} from "./DocumentsTypes/utils";
import {DeliveryCutoffRule, parseDeliveryCutoffRules} from '../utils/hourLock';

interface Product {
    id: number; // dont show
    name: string; // name of the agent;
    barcode: string; //
    default_price: number;
    position: number;
    active: boolean;
    isClientProduct: boolean;

    isNoTax: boolean;
    taklit_id: number;
    taklit_type: number;
    external_id: string;
    unit: string;
    unit_amount: number;
    cost_price: number;
    cost_price_updated?: number;
    category: string;
    category2: string;
    base_price: number;
    return_cost: boolean;
    connected_products: Product[];
    min_amount?: number;
    forceLock?: boolean;
    hourLock?: Date;
    dayHourLocks?: Record<string, string>;
    deliveryCutoffRules?: Record<string, DeliveryCutoffRule>;
    dayLock?: number[];
    sale?: boolean;
    unit_preferece?: number
    step?: number;
    p_range?: number;
    armor?:number;
    days_ahead?: number;
    notes2?: string;
    notes3?: string;
    notes4?: string;
    notes5?: string;
    notes6?: string;

    collector?: number;
    // filling later

    image?: any;
    extra_unit?: string | 0;
    conversion_rate?: number;
    third_unit?: string | 0;
    /** Supplier product whose units come from its linked client product (read-only here). */
    units_linked?: boolean;
    split_category?: number;
    available?: boolean;
    weight?: number;
    volume?: number;
    englishName?: string;
    orderName?: string;
    orderPosition?: number;
    nkObject: any;
}

export const getImgFromDB = (p: any): string => {
    let img = emptyPhoto;
    const temp_img = JSDB().getProductImage(Number(p.id)).first;
    if (temp_img === null || byteArrayToImg(temp_img) === (badPhoto) || temp_img === '')
        img = undefined;
    else
        img = byteArrayToImg(temp_img);
    return img;
};
export const updateImg = (p: Product) => {
    p.image = getImgFromDB(p);
};
export const deserializeDayLock = (dayLock: any): number => {
    let s = 0
    dayLock.forEach((d: any) => {
        s += Math.pow(2, d-1)
    })
    return s
}

const parseDayHourLocks = (value: unknown): Record<string, string> => {
    if (!value) return {};
    if (typeof value === 'object') return value as Record<string, string>;
    try {
        const parsed = JSON.parse(String(value));
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
    } catch {
        return {};
    }
};

const supplierUnits = (p: any) => {
    if (p.isClient) return {};
    const rate = p.effectiveConversionRate();
    return {
        unit: p.getEffectiveUnitName(),
        extra_unit: p.getEffectiveExtraUnitName() ?? null,
        conversion_rate: rate > 0 ? rate : null,
        third_unit: p.getEffectiveThirdUnitName() ?? null,
        unit_preferece: p.effectiveUnitPreference(),
        units_linked: p.unitsFromLinked(),
    };
};

export const deserializeProduct = (p: any): Product => {
    const o = p.getOrderProduct();
    const cp = p.getConnectedProduct()
    const cost_price_updated = JSDB().getProductCost(p.id)?.get(dateObjectToString(new Date()))?.first

    return {
        active: p.getActive(),
        barcode: p.getBarcode(),
        connected_products: (cp.size > 0) ? cp.toArray() : [],
        default_price: p.getDefaultPrice(),
        external_id: p.getExternalId(),
        id: p.id,
        isClientProduct: p.isClient,
        isNoTax: p.getNoTaxProduct() === 1,
        name: p.getName(),
        position: p.getPosition(),
        taklit_id: p.taklit_id,
        taklit_type: p.taklit_type,
        unit: p.getUnitName(),
        unit_amount: p.getUnitAmmount(),
        category: p.getCategory(),
        cost_price: p.getCostPrice(),
        base_price: p.getBasePrice(),
        split_category: p.split_category,
        // return_cost:p.getCostIncludeReturns()==1,
        return_cost: p.cost_include_returns == 1,
        extra_unit: o?.getExtraUnitName() ?? null,
        conversion_rate: o?.conversion_rate ?? null,
        third_unit: o?.getThirdUnitName() ?? null,
        available: o?.available === 1 ?? null,
        weight: o?.weight ?? null,
        volume: o?.volume ?? null,
        englishName: o?.englishName ?? null,
        orderName: o?.orderName ?? null,
        orderPosition: o?.position ?? null,
        armor:o?.armor ?? 0,
        nkObject: p,
        category2: p.category2,
        step: o?.step ?? 0,
        min_amount: o?.min_order ?? 0,
        sale: o?.sales == 1,
        collector: o?.collector ?? -1,
        forceLock: o?.forceLock == 1,
        cost_price_updated: cost_price_updated ?? 0,
        days_ahead: o?.days_ahead ?? 0,
        notes2:p.notes2,
        notes3:p.notes3,
        notes4:p.notes4,
        notes5:p.notes5,
        notes6:p.notes6,



        hourLock: o?.hourLock ? stringToTime(o?.hourLock): stringToTime('00:00'),
        // Kotlin/JS stores these as *_1 on the instance; InteropShims expose the clean names,
        // but keep the mangled fallback (same pattern as day_hour_locks) so Redux still fills
        // when the prototype getter is missing for any reason.
        dayHourLocks: parseDayHourLocks(o?.day_hour_locks ?? o?.day_hour_locks_1),
        deliveryCutoffRules: parseDeliveryCutoffRules(
            o?.delivery_cutoff_rules ?? o?.delivery_cutoff_rules_1
        ),
        dayLock: o ? toArrayOrEmpty(o?.daysInt()) : [],
        unit_preferece: o?.unit_preferece ?? 0,
        p_range:p?.p_range ?? 0,
        image: getImgFromDB(p),
        ...supplierUnits(p),
    };
};

export const makeProduct = ({
                                id = -1,
                                name = '',
                                barcode = '',
                                default_price = 0,
                                position = 0,
                                active = true,
                                isClientProduct = false,

                                isNoTax = false,
                                taklit_id = -1,
                                taklit_type = -1,
                                external_id = "",
                                unit = '',
                                unit_amount = 0,
                                category = '',
                                cost_price = 0,
                                cost_price_updated = 0,
                                base_price = 0,
                                return_cost = true,
                                connected_products = [],
                                category2 = '',
                                image = emptyPhoto,
                                extra_unit = '',
                                conversion_rate = 0,
                                third_unit = '',
                                units_linked = false,
                                available = true,
                                weight = 0,
                                volume = 0,
                                englishName = '',
                                step = 0,
                                forceLock = false,
                                hourLock = '',
                                dayHourLocks = {},
                                deliveryCutoffRules = {},
                                dayLock = [1, 2, 3, 4, 5, 6, 7],
                                sale = false,
                                unit_preferece = 0,
                                default_unit = 0,
                                days_ahead=0,
                                collector = -1,
    notes2,
    notes3,
    notes4,
    notes5,
    notes6,
    p_range=0,
    armor=0,
                            min_amount = 0,
                                split_category = 0,
                                nkObject = null
                            }) => ({
    id,
    name,
    barcode,
    default_price,
    position,
    active,
    isClientProduct,
    return_cost,
    isNoTax,
    taklit_id,
    taklit_type,
    external_id,
    category2,
    unit,
    unit_amount,
    category,
    cost_price,
    cost_price_updated,
    connected_products,
    base_price,
    image,
    extra_unit,
    conversion_rate,
    third_unit,
    units_linked,
    available,
    weight,
    volume,
    englishName,
    step,
    forceLock,
    hourLock,
    dayHourLocks,
    deliveryCutoffRules,
    dayLock,
    sale,
    days_ahead,
    unit_preferece,
    default_unit,
    collector,
    min_amount,
    split_category,
    armor,
    p_range,
    notes2,
    notes3,
    notes4,
    notes5,

    notes6,
    nkObject
});

export default Product;
